import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/enterprise-consult',
    name: 'enterprise-consult',
    component: () => import(/* webpackChunkName: "enterprise-consult" */ '../views/EnterpriseConsultView.vue')
  },
  {
    path: '/enterprise-wechat',
    name: 'enterprise-wechat',
    component: () => import(/* webpackChunkName: "enterprise-wechat" */ '../views/EnterpriseWechatView.vue')
  },
  {
    path: '/helperCenter',
    name: 'helperCenter',
    component: () => import(/* webpackChunkName: "HelperCenter" */ '../views/HelperCenter.vue')
  },
  {
    path: '/package-service',
    name: 'package-service',
    component: () => import(/* webpackChunkName: "package-service" */ '../views/PackageServiceView.vue')
  },
  {
    path: '/recharge',
    name: 'recharge-center',
    component: () => import(/* webpackChunkName: "recharge-center" */ '../views/RechargeCenterView.vue')
  },
  {
    path: '/payment-order',
    name: 'payment-order',
    component: () => import(/* webpackChunkName: "payment-order" */ '../views/PaymentOrderView.vue')
  },
  {
    path: '/payment-order/pay/:orderId',
    name: 'payment-pay',
    component: () => import(/* webpackChunkName: "payment-pay" */ '../views/PaymentPayView.vue')
  },
  {
    path: '/payment-order/pay',
    redirect: '/payment-order'
  },
  {
    path: '/payment-result/:orderId',
    name: 'payment-result',
    component: () => import(/* webpackChunkName: "payment-result" */ '../views/PaymentSuccessView.vue')
  },
  {
    path: '/payment-result',
    redirect: '/payment-order'
  },
  {
    path: '/payment-success/:orderId',
    name: 'payment-success',
    component: () => import(/* webpackChunkName: "payment-success" */ '../views/PaymentSuccessView.vue')
  },
  {
    path: '/payment-success',
    redirect: '/payment-order'
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
